import { Link } from "react-router-dom";
import { Languages } from "lucide-react";

interface LanguageSwitchLinkProps {
  href: string;
  label: string;
  className?: string;
}

/**
 * Subtle inline link used to cross-link English <-> Spanish versions
 * of the same educational page. Not a sales CTA.
 */
export default function LanguageSwitchLink({ href, label, className = "" }: LanguageSwitchLinkProps) {
  return (
    <Link
      to={href}
      className={`inline-flex items-center gap-1.5 text-sm font-semibold text-white/70 underline-offset-4 hover:text-white hover:underline ${className}`}
    >
      <Languages className="h-3.5 w-3.5" aria-hidden="true" />
      {label}
    </Link>
  );
}
